module.exports = __webpack_public_path__ + "static/media/img5.032a89c7.jpg";